import React, { useState } from "react";
import { Pencil, Trash2 } from "lucide-react";
import styles from "../genre/genre.module.scss";
import noImageUrl from "../../images/no-image.png";
import { convertToCloudFrontUrl } from "../../helper";

const GenreCard = ({ genre, onEditSuccess, onDeleteSuccess }) => {
  const selectedGenreName = genre.translations?.find((t) => t.langCode === "en");
  const [imageError, setImageError] = useState(false);

  const cloudUrl = genre.image?.uploadedImageUrl
    ? convertToCloudFrontUrl(genre.image.uploadedImageUrl)
    : null;
  const imgSrc = imageError || !cloudUrl ? noImageUrl : cloudUrl;

  const handleImageError = () => {
    const brokenUrl = genre.image?.uploadedImageUrl;
    console.error("[Genre Image Error] AccessDenied or failed to load:", {
      url: brokenUrl,
      genreId: genre._id,
      genreName: selectedGenreName?.name || "Unknown",
    });
    setImageError(true);
  };

  const displayName = selectedGenreName?.name || "Uncategorized";
  const typeLabel = genre.type === "Fiction" ? "Fiction" : "Nonfiction";

  return (
    <article className={styles.genreCard}>
      <div className={styles.genreCardMedia}>
        <img
          className={styles.image}
          src={imgSrc}
          alt=""
          onError={handleImageError}
        />
        <div className={styles.mediaOverlay} aria-hidden />
        <div className={styles.genreCardActions}>
          <button
            type="button"
            className={styles.iconActionBtn}
            onClick={(e) => {
              e.stopPropagation();
              onEditSuccess(genre._id);
            }}
            aria-label="Edit genre"
            title="Edit genre"
          >
            <Pencil size={18} strokeWidth={2} aria-hidden />
          </button>
          <button
            type="button"
            className={`${styles.iconActionBtn} ${styles.iconActionBtnDanger}`}
            onClick={(e) => {
              e.stopPropagation();
              onDeleteSuccess(genre._id);
            }}
            aria-label="Delete genre"
            title="Delete genre"
          >
            <Trash2 size={18} strokeWidth={2} aria-hidden />
          </button>
        </div>
      </div>

      <footer className={styles.genreCardFooter}>
        <div className={styles.categoryBlock}>
          <div className={styles.categoryBadges}>
            <span className={styles.categoryBadgePrimary} title={displayName}>
              {displayName}
            </span>
          </div>
        </div>
        <div className={styles.typeBadge} title={typeLabel}>
          {typeLabel}
        </div>
      </footer>
    </article>
  );
};

export default GenreCard;
